//*********************************
// masonry-isotope
//*********************************

console.log('masonry-isotope');

import Masonry from 'masonry-layout';
import Isotope from 'isotope-layout';
import matchesSelector from 'desandro-matches-selector';
import imagesLoaded from 'imagesloaded';
import InfiniteScroll from 'infinite-scroll';

//assign infinite scroll to imagesloaded
InfiniteScroll.imagesLoaded = imagesLoaded;


//*******************************
// Masonry (Vanilla JS) 
//*******************************

var elemMasonry = document.querySelector('.masonry-element');
if (elemMasonry) {
	var msnry = new Masonry( elemMasonry, {
	  // options
	  itemSelector: '.cell'
	});
}

//*******************************
// Masonry & IL (Vanilla JS) 
//*******************************

var elemMasonryIl = document.querySelector('.masonry-il');
if (elemMasonryIl) {
 var msnry = new Masonry( elemMasonryIl, {
  itemSelector: 'none', // select none at first
  columnWidth: '.cell',
  percentPosition: true,
  stagger: 30,
  // nicer reveal transition
  visibleStyle: { transform: 'translateY(0)', opacity: 1 },
  hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
 });
 // initial items reveal
 imagesLoaded( elemMasonryIl, function() {
   elemMasonryIl.classList.remove('are-images-unloaded');
   msnry.options.itemSelector = '.cell';
   var items = elemMasonryIl.querySelectorAll('.cell');
   msnry.appended( items );
 });
 // Callbacks
	msnry.on( 'layoutComplete', function( items ) {
	 //console.log( items.length );
	});
}

//*******************************
// Masonry & IL & IS (Vanilla JS) 
//*******************************

var elemMasonryIs = document.querySelector('.masonry-is');
if (elemMasonryIs) {
 var msnry = new Masonry( elemMasonryIs, {
  itemSelector: 'none', // select none at first
  columnWidth: '.cell',
  percentPosition: true,
  stagger: 30,
  // nicer reveal transition
  visibleStyle: { transform: 'translateY(0)', opacity: 1 },
  hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
 });
 // initial items reveal
 imagesLoaded( elemMasonryIs, function() {
   elemMasonryIs.classList.remove('are-images-unloaded');
   msnry.options.itemSelector = '.cell';
   var items = elemMasonryIs.querySelectorAll('.cell');
   msnry.appended( items );
 });
 // load pages
 var links = document.querySelectorAll('.nav-is a');
 var nextPageSlugs = [];
 for(var i = 0; i < links.length; i++){
   nextPageSlugs.push(links[i].href);
 }
 function getPagePath() {
   var slug = nextPageSlugs[ this.loadCount ];
  if (typeof(slug) !== 'undefined') {
    return slug;
   }
 }
 // init Infinite Scroll
 var infScroll = new InfiniteScroll( elemMasonryIs, {
   path: getPagePath,
   append: '.cell',
   outlayer: msnry,
   status: '.page-load-status',
			history: false,
   //using button, disable loading on scroll
   //button: '.view-more-button',   
   //scrollThreshold: false,
 });
 // Callbacks
	msnry.on( 'layoutComplete', function( items ) {
	 //console.log( items.length );
	});
 infScroll.on( 'append', function( response, path, items ) {
  //console.log( 'append ' + path );
 });
 infScroll.on( 'load', function( response, path ) {
  //console.log( 'load ' + path  );
 });
}

//*******************************
// Isotope (Vanilla JS) 
//*******************************

var elemIsotope = document.querySelector('.isotope');
if (elemIsotope) {

	// init Isotope
	var iso = new Isotope( elemIsotope, {
	  itemSelector: '.cell',
	  layoutMode: 'fitRows',
	  getSortData: {
	    name: '.name',
	    symbol: '.symbol',
	    number: '.number parseInt',
	    category: '[data-category]',
	    weight: function( itemElem ) {
	      var weight = itemElem.querySelector('.weight').textContent;
	      return parseFloat( weight.replace( /[\(\)]/g, '') );
	    }
	  }
	});
	
	// filter functions
	var filterFns = {
	  // show if number is greater than 50
	  numberGreaterThan50: function( itemElem ) {
	    var number = itemElem.querySelector('.number').textContent;
	    return parseInt( number, 10 ) > 50;
	  },
	  // show if name ends with -ium
	  ium: function( itemElem ) {
	    var name = itemElem.querySelector('.name').textContent;
	    return name.match( /ium$/ );
	  }
	};
	
	// bind filter button click
	var filtersElem = document.querySelector('.filters-button-group');
	filtersElem.addEventListener( 'click', function( event ) {
	  // only work with buttons
	  if ( !matchesSelector( event.target, 'button' ) ) {
	    return;
	  }
	  var filterValue = event.target.getAttribute('data-filter');
	  // use matching filter function
	  filterValue = filterFns[ filterValue ] || filterValue;
	  iso.arrange({ filter: filterValue });
	});
	
	// change is-checked class on buttons
	var buttonGroups = document.querySelectorAll('.button-group');
	for ( var i=0, len = buttonGroups.length; i < len; i++ ) {
	  var buttonGroup = buttonGroups[i];
	  radioButtonGroup( buttonGroup );
	}
	
	function radioButtonGroup( buttonGroup ) {
	  buttonGroup.addEventListener( 'click', function( event ) {
	    // only work with buttons
	    if ( !matchesSelector( event.target, 'button' ) ) {
	      return;
	    }
	    buttonGroup.querySelector('.is-checked').classList.remove('is-checked');
	    event.target.classList.add('is-checked');
	  });
	}

	// bind sort button click
	var sortByGroup = document.querySelector('.sort-by-button-group');
	sortByGroup.addEventListener( 'click', function( event ) {
	  // only button clicks
	  if ( !matchesSelector( event.target, '.button' ) ) {
	    return;
	  }
	  var sortValue = event.target.getAttribute('data-sort-value');
	  iso.arrange({ sortBy: sortValue });
	});
	
	// change is-checked class on buttons
	var buttonGroups = document.querySelectorAll('.button-group');
	for ( var i=0; i < buttonGroups.length; i++ ) {
	  buttonGroups[i].addEventListener( 'click', onButtonGroupClick );
	}
	
	function onButtonGroupClick( event ) {
	  // only button clicks
	  if ( !matchesSelector( event.target, '.button' ) ) {
	    return;
	  }
	  var button = event.target;
	  button.parentNode.querySelector('.is-checked').classList.remove('is-checked');
	  button.classList.add('is-checked');
	}

 // Callbacks
 iso.on( 'layoutComplete', function( laidOutItems ) {
	 //console.log('layoutComplete');
 });
 
	iso.on( 'arrangeComplete', function() {
	 //console.log('arrangeComplete');
	});

}

//*******************************
// Isotope & IL (Vanilla JS) 
//*******************************

var elemIsotopeIl = document.querySelector('.isotope-il');
var iso;
if (elemIsotopeIl) {
 imagesLoaded( elemIsotopeIl, function() {
  // init Isotope after all images have loaded
  iso = new Isotope( elemIsotopeIl, {
   itemSelector: '.cell',
   percentPosition: true,
   masonry: {
     columnWidth: '.cell'
   }
  });
  // filter Array
  var filters = [];
  
  // bind filter button click
  var filtersElem = document.querySelector('.filters-button-group');
  if ( filtersElem ) {
  
  filtersElem.addEventListener( 'click', function( event ) {
   var buttonvalues = filtersElem.getElementsByClassName('button');
   if(event.target.className.indexOf('button-all') !== -1){
    for (i=1; i < buttonvalues.length; i++) {
     filters = [];
     buttonvalues[i].classList.remove('is-checked');
     buttonvalues[0].classList.add('is-checked');
    }
   } else {
    //var isChecked = event.target.className('is-checked');
    var isChecked = event.target.classList.toggle('is-checked');
    var filterValue = event.target.getAttribute('data-filter');
    buttonvalues[0].classList.remove('is-checked');
    if ( isChecked ) {
     addFilter( filterValue );
    } else {
     removeFilter( filterValue );
    }
   }
   // add Filters to Filter Array
   function addFilter( filterValue ) {
    filters.push( filterValue );
    //console.log('added');
   }
   // remove Filters from Filter Array
   function removeFilter( filterValue ) {
    var index = filters.indexOf( filterValue);
    filters.splice( index, 1 );
    //console.log('removed');
   }
   // only work with buttons
   if ( !matchesSelector( event.target, 'button' ) ) {
    return;
   }
   var filterValue = event.target.getAttribute('data-filter');
    // use matching filter function
    //filterValue = filterFns[ filterValue ] || filterValue;
    iso.arrange({ filter:  filters.join(',') });
   });
  }
 });
 // Callbacks
/*
 iso.on( 'layoutComplete', function( laidOutItems ) {
	 //console.log('layoutComplete');
 });
 
	iso.on( 'arrangeComplete', function() {
	 //console.log('arrangeComplete');
	});
*/
	
}

//*******************************
// Isotope & IL & IS (Vanilla JS) 
//*******************************

//assign infinite scroll to imagesloaded
InfiniteScroll.imagesLoaded = imagesLoaded;

var elemIsotopeIs = document.querySelector('.isotope-is');
if ( elemIsotopeIs) {
 
 // init isotope
 var iso = new Isotope( elemIsotopeIs, {
  masonry: {
   columnWidth: '.cell',
   horizontalOrder: true
  },
  itemSelector: 'none', // select none at first
  columnWidth: '.cell',
  percentPosition: true,
  stagger: 30,
  // nicer reveal transition
  visibleStyle: { transform: 'translateY(0)', opacity: 1 },
  hiddenStyle: { transform: 'translateY(100px)', opacity: 0 },
 });
 
 // filter Array
 var filters = [];
 
 // bind filter button click
 var filtersElem = document.querySelector('.filters-button-group');
 if ( filtersElem ) {
 
 filtersElem.addEventListener( 'click', function( event ) {
  var buttonvalues = filtersElem.getElementsByClassName('button');
  if(event.target.className.indexOf('button-all') !== -1){
   for (i=1; i < buttonvalues.length; i++) {
    filters = [];
    buttonvalues[i].classList.remove('is-checked');
    buttonvalues[0].classList.add('is-checked');
   }
  } else {
   //var isChecked = event.target.className('is-checked');
   var isChecked = event.target.classList.toggle('is-checked');
   var filterValue = event.target.getAttribute('data-filter');
   buttonvalues[0].classList.remove('is-checked');
   if ( isChecked ) {
    addFilter( filterValue );
   } else {
    removeFilter( filterValue );
   }
  }
  // add Filters to Filter Array
  function addFilter( filterValue ) {
   filters.push( filterValue );
   //console.log('added');
  }
  // remove Filters from Filter Array
  function removeFilter( filterValue ) {
   var index = filters.indexOf( filterValue);
   filters.splice( index, 1 );
   //console.log('removed');
  }
  // only work with buttons
  if ( !matchesSelector( event.target, 'button' ) ) {
   return;
  }
  var filterValue = event.target.getAttribute('data-filter');
   // use matching filter function
   //filterValue = filterFns[ filterValue ] || filterValue;
   iso.arrange({ filter:  filters.join(',') });
  });
 }

 // initial items reveal
 imagesLoaded( elemIsotopeIs, function() {
  elemIsotopeIs.classList.remove('are-images-unloaded');
  iso.options.itemSelector = '.cell';
  var items =  elemIsotopeIs.querySelectorAll('.cell');
  iso.appended( items );
 });
 // load pages
 var links = document.querySelectorAll('.nav-is a');
 var nextPageSlugs = [];
 for(var i = 0; i < links.length; i++){
  nextPageSlugs.push(links[i].href);
 }
 function getPagePath() {
  var slug = nextPageSlugs[ this.loadCount ];
  if (typeof(slug) !== 'undefined') {
    return slug;
   }
 }
 // init Infinite Scroll
 var infScroll = new InfiniteScroll( elemIsotopeIs, {
  path: getPagePath,
  append: '.cell',
  outlayer: iso,
  status: '.page-load-status',
  history: false,
  //using button, disable loading on scroll
  //button: '.view-more-button',
  //scrollThreshold: false,
 });

 // Callbacks
/*
 iso.on( 'layoutComplete', function( laidOutItems ) {
	 //console.log('layoutComplete');
 });
 
	iso.on( 'arrangeComplete', function() {
	 //console.log('arrangeComplete');
	});
*/
	
 infScroll.on( 'append', function( response, path, items ) {
  //console.log( 'append ' + path );
 });
 
 infScroll.on( 'load', function( response, path ) {
  //console.log( 'load ' + path  );
 });

}
